import { useTranslation } from "react-i18next";
import { CloseOutlined, SaveOutlined } from '@ant-design/icons';
import {
  Button,
  Form, Input,
  Select, Space, Typography, message
} from 'antd';
import { KeyboardEvent, useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DrawerCustom from '../Drawer';
import CustomTransferStudentTable from './CustomTransferStudentTable';

type Props = {
  open: boolean;
  handleClose: () => void;
  classId?: number;
  onSubmit?: (values: any) => void;
  apiUrl: any;
  loadingConfirm?: boolean
};

interface RecordType {
  key: string;
  name: string;
  username: string;
}

const AddStudentToCourseDrawer = ({
  open,
  handleClose,
  onSubmit,
  apiUrl,
  loadingConfirm
}: Props) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [filterForm] = Form.useForm();
  const { id } = useParams();

  const [dataStudents, setDataStudents] = useState<RecordType[]>([]);
  const [targetKeys, setTargetKeys] = useState<string[]>([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });
  const [selectedData, setSelectedData] = useState<RecordType[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const fetchStudents = useCallback(async () => {
    setIsLoading(true)
    try {
      const values = form.getFieldsValue();
      const payload = {
        page: pagination.current,
        size: pagination.pageSize,
        courseId: Number(id),
        keyword: values?.name || '',
        // universityIds: values?.school ? [values.school] : [],
        // industryIds: values?.major ? [values.major] : [],
      };

      const res = await apiUrl(payload);
      const allData: RecordType[] = (res.data.data.content || []).map((s: any) => ({
        key: s.id.toString(),
        name: s.name,
        username: s.username,
      }));
      setDataStudents(allData);
      setPagination((prev) => ({ ...prev, total: res.data.data.totalElements }));
    } catch (err) {
      message.error(t("Không thể tải danh sách học viên.", "Không thể tải danh sách học viên."));
    }
    finally {
      setIsLoading(false)
    }
  }, [id, pagination.current, pagination.pageSize, form]);

  useEffect(() => {
    if (open) fetchStudents();
  }, [fetchStudents, open]);

  useEffect(() => {
    setTargetKeys([]);
    form.resetFields();
    filterForm.resetFields();
    setSelectedData([])
  }, [open]);

  const handleFilter = () => {
    setPagination((prev) => ({ ...prev, current: 1 }));
    fetchStudents();
  };

  const handleSave = () => {
    form.validateFields().then(values => {
      onSubmit?.({ ...values, listStudent: targetKeys });
    }).catch(() => {
      message.error(t("Vui lòng kiểm tra lại form.", "Vui lòng kiểm tra lại form."));
    });
  };

  const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      fetchStudents();
    }
  };
  return (
    <DrawerCustom
      title={t("Thêm học viên", "Thêm học viên")}
      open={open}
      onClose={handleClose}
      widthDrawer={800}
      extraNode={
        <Space>
          <Button onClick={handleClose} className="btn btn-outlined">
            <CloseOutlined />
            <Typography.Text>{t("Hủy", "Hủy")}</Typography.Text>
          </Button>
          <Button className="btn btn-primary"
            loading={loadingConfirm}
            disabled={targetKeys?.length === 0}
            onClick={handleSave}>
            <SaveOutlined />
            <Typography.Text>{t("Lưu", "Lưu")}</Typography.Text>
          </Button>
        </Space>
      }
    >
      <Form form={form} layout="vertical">
        <div className='flex gap-16 flex-wrap'>
          {/* <div className='flex-1'>
            <Form.Item name="school" label={t("Trường", "Trường")} >
              <Select placeholder={t("Chọn trường", "Chọn trường")} mode="multiple"
                allowClear />
            </Form.Item>
          </div>
          <div className='flex-1'>
            <Form.Item name="major" label={t("Chuyên ngành", "Chuyên ngành")}>
              <Select placeholder={t("Chọn chuyên ngành", "Chọn chuyên ngành")} mode="multiple"
                allowClear />
            </Form.Item>
          </div> */}
          <div className='flex-1'>
            <Form.Item name="name" label={t("Tên học viên", "Tên học viên")}>
              <Input allowClear placeholder={t("Nhập tên học viên cần tìm", "Nhập tên học viên cần tìm")}
                onKeyDown={handleSearch}
              />
            </Form.Item>
          </div>
          <Form.Item label=" ">
            <Button type="primary" onClick={handleFilter}>
              {t("Lọc", "Lọc")}
            </Button>
          </Form.Item>
        </div>

      </Form>

      <Form form={form} name="createStudent">
        <div className="student-transfer">
          <Form.Item name="listStudent">
            <CustomTransferStudentTable
              data={dataStudents}
              selectedKeys={targetKeys}
              selectedData={selectedData}
              onChange={(keys, records) => {
                setTargetKeys(keys);
                setSelectedData(records);
              }}
              onLeftPageChange={(page, size) =>
                setPagination(prev => ({ ...prev, current: page, pageSize: size }))
              }
              leftPagination={pagination}
              loading={isLoading}
            />

          </Form.Item>
        </div>
      </Form>
    </DrawerCustom>
  );
};

export default AddStudentToCourseDrawer;
